import { IWorkerDrugTestingSchedulesResponse, IWorkerThirdPartyDrugTestResultsResponse } from 'models/drugTesting';

export interface IContact {
  id: string;
  contactType: 0 | 1;
  contactValue: string;
  isPrimary: boolean;
  isVerified: boolean;
}

export interface IWorkerDataState {
  consentFormInformation?: any;
  profileCustomFieldsConfig?: any;
  myCertifications?: {
    current: {
      items: any[];
      pageNumber: number;
      pageSize: number;
      totalResults: number;
    } | null;
    expired: {
      items: any[];
      pageNumber: number;
      pageSize: number;
      totalResults: number;
    } | null;
    required: {
      items: any[];
      pageNumber: number;
      pageSize: number;
      totalResults: number;
    } | null;
  };
  drugTestingSchedules?: IWorkerDrugTestingSchedulesResponse | null;
  thirdPartyDrugTestResults?: IWorkerThirdPartyDrugTestResultsResponse | null;
  workerCourses: {
    active: any[];
    expired: any[];
    pagination?: {
      active?: { currentPage: number; totalPages: number; totalRecords: number; limit: number };
      expired?: { currentPage: number; totalPages: number; totalRecords: number; limit: number };
    };
  };
  contacts: {
    emails: IContact[];
    phones: IContact[];
  };
  adminContacts: {
    emails: IContact[];
    phones: IContact[];
  };
  workerProjects: {
    current: any[];
    past: any[];
    pending: any[];
    pagination?: {
      current?: { pageNumber: number; pageSize: number; totalResults: number };
      past?: { pageNumber: number; pageSize: number; totalResults: number };
      pending?: { pageNumber: number; pageSize: number; totalResults: number };
    };
  };
}

const initialState: IWorkerDataState = {
  consentFormInformation: {},
  profileCustomFieldsConfig: null,
  myCertifications: {
    current: null,
    expired: null,
    required: null,
  },
  drugTestingSchedules: null,
  thirdPartyDrugTestResults: null,
  workerCourses: {
    active: [],
    expired: [],
    pagination: {
      active: { currentPage: 1, totalPages: 0, totalRecords: 0, limit: 9 },
      expired: { currentPage: 1, totalPages: 0, totalRecords: 0, limit: 9 },
    },
  },
  contacts: {
    emails: [],
    phones: [],
  },
  adminContacts: {
    emails: [],
    phones: [],
  },
  workerProjects: {
    current: [],
    past: [],
    pending: [],
    pagination: {
      current: { pageNumber: 1, pageSize: 12, totalResults: 0 },
      past: { pageNumber: 1, pageSize: 12, totalResults: 0 },
      pending: { pageNumber: 1, pageSize: 12, totalResults: 0 },
    },
  },
};

export default initialState;
